import { Alert, Card, Col, Row, Space, Spin } from 'antd';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@fortawesome/fontawesome-svg-core';

interface TopicsUsageListProps {
  company: Company | undefined;
  hasFeature: boolean;
}

export default function TopicsUsage({
  company, hasFeature
}: TopicsUsageListProps) {
    
  const usage = CustomerServiceQueries.useCompanyUsageTopics(company!.id)

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faClone as Icon}/> Topics</Space>}>
        <Spin spinning={usage.isLoading}>
            
    <Row gutter={[16,16]}>
        {hasFeature ?
        usage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        )) :
        <Alert showIcon message="This company does not have the Topics feature" style={{width: '100%'}}/>
        }
    </Row>
        </Spin>
    </Card>
    </>
  );
}
